export const gameSize = 50;